import React from "react";

const Layout = ({ children }) => {
    return (
        <div>
            <div className="container mt-3">
                <div className="container mt-5 mb-5">
                    <h2 className="mb-4">Branch Manager Dashboard</h2>
                    {children}
                </div>
            </div>
        </div>
    );
}

export default Layout;